export enum UserRole {
	ADMIN = "global_admin",
	COACH = "coach",
	PARTNER_ADMIN = "partner_admin",
	ORG_ADMIN = "org_admin",
	ASSESSEE = "assessee",
}
